export const hasActualValue = value =>
  value !== null && value !== undefined && value !== '';

export const getActualNumber = value => {
  if (!hasActualValue(value)) return 0;

  const numericValue = Number(String(value).replace(/,/g, ''));
  return Number.isFinite(numericValue) ? numericValue : 0;
};

export const summarizeActualRows = rows => {
  const summary = {
    actualTotal: 0,
    hasActuals: false,
  };

  (rows || []).forEach(row => {
    if (!hasActualValue(row?.actual)) return;
    summary.hasActuals = true;
    summary.actualTotal += getActualNumber(row.actual);
  });

  summary.actualTotal = parseFloat(summary.actualTotal.toFixed(2));
  return summary;
};

export const summarizeBudgetActuals = budgetData => {
  const summary = {
    actualTotal: 0,
    hasActuals: false,
  };

  const addRows = rows => {
    const rowSummary = summarizeActualRows(rows);
    if (rowSummary.hasActuals) {
      summary.hasActuals = true;
      summary.actualTotal += rowSummary.actualTotal;
    }
  };

  const visitLineItems = lineItems => {
    (lineItems || []).forEach(item => {
      addRows(item?.swimlane_item_detail_sheets);
      visitLineItems(item?.children);
    });
  };

  (budgetData?.budget_swimlane || []).forEach(swimlane => {
    addRows(swimlane?.swimlane_detail_sheets);
    visitLineItems(swimlane?.budget_swimlane_lineitem);
  });

  summary.actualTotal = parseFloat(summary.actualTotal.toFixed(2));
  return summary;
};
